import { render, staticRenderFns } from "./dandelion-store.vue?vue&type=template&id=23561de3&"
import script from "./dandelion-store.vue?vue&type=script&lang=js&"
export * from "./dandelion-store.vue?vue&type=script&lang=js&"
import style0 from "./dandelion-store.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports